import { useEffect } from 'react';

import { useConfig } from '../../../../context/config-provider';
import { SentryService } from '../../../../services/sentry';
import { loadScript } from '../../../../utils/utils';

export function useAntillephone() {
  const {
    site: { license: { id, imageSize } = {} },
  } = useConfig();

  useEffect(() => {
    if (id) {
      loadScript(`https://${id}.snippet.antillephone.com/apg-seal.js`)
        .then(() => {
          if (typeof window.APG?.init === 'function') {
            window.APG.init();
          }
        })
        .catch(SentryService.captureException);
    }
  }, []);

  return { id, imageSize };
}
